import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BackToTopButton from '@/components/base/BackToTopButton';
import HeroBanner from './components/HeroBanner';
import CategoryTabs from './components/CategoryTabs';
import MovieGrid from './components/MovieGrid';
import FeaturesBar from './components/FeaturesBar';
import { allMovies } from '@/mocks/movies';

const homeMovies = allMovies.filter((m) => m.category === 'movie').slice(0, 6);
const homeTV = allMovies.filter((m) => m.category === 'tv').slice(0, 6);
const homeAnime = allMovies.filter((m) => m.category === 'anime').slice(0, 6);
const homeVariety = allMovies.filter((m) => m.category === 'variety').slice(0, 6);
const topRated = [...allMovies].sort((a, b) => b.rating - a.rating).slice(0, 6);

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '午马影院',
    url: 'https://wumacinema.com',
    description: '午马影院为您提供高清不缓冲免费在线影视，涵盖最新电影、热播剧集，流畅播放免注册，即点即看无需等待。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://wumacinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '午马影院',
    url: 'https://wumacinema.com',
    description: '高清不缓冲免费在线影视平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-9999',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '午马影院需要注册吗？',
        acceptedAnswer: { '@type': 'Answer', text: '不需要注册，午马影院完全免费免注册，打开即可观看所有内容。' },
      },
      {
        '@type': 'Question',
        name: '午马影院的画质如何？',
        acceptedAnswer: { '@type': 'Answer', text: '午马影院提供4K超清画质，采用智能CDN加速技术，播放流畅不卡顿。' },
      },
      {
        '@type': 'Question',
        name: '午马影院支持哪些设备？',
        acceptedAnswer: { '@type': 'Answer', text: '支持电脑、平板、手机等多终端观看，只需浏览器即可享受高清影视。' },
      },
      {
        '@type': 'Question',
        name: '午马影院更新速度快吗？',
        acceptedAnswer: { '@type': 'Answer', text: '每日更新最新电影和热播剧集，与院线和平台同步更新，资源丰富。' },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroBanner />
          <CategoryTabs />

          <div id="featured-movies">
            <MovieGrid
              title="🔥 热门推荐"
              movies={topRated}
              viewAllLink="/category/dianying"
            />
          </div>

          <FeaturesBar />

          <MovieGrid
            title="🎬 最新电影"
            movies={homeMovies}
            viewAllLink="/category/dianying"
          />

          <MovieGrid
            title="📺 热播剧集"
            movies={homeTV}
            viewAllLink="/category/dianshiju"
          />

          <MovieGrid
            title="🎮 精品动漫"
            movies={homeAnime}
            viewAllLink="/category/dongman"
          />

          <MovieGrid
            title="🎤 热门综艺"
            movies={homeVariety}
            viewAllLink="/category/zongyi"
          />

          <div id="latest-updates">
            <MovieGrid
              title="⭐ 高分纪录片"
              movies={allMovies.filter((m) => m.category === 'documentary')}
              viewAllLink="/category/jilupian"
            />
          </div>

          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-primary-500">
            <div className="max-w-[1400px] mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
                免费观影，即刻开始
              </h2>
              <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-6">
                无需注册，无需付费，打开午马影院即可畅享海量高清影视资源
              </p>
              <a
                href="#featured-movies"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-white text-primary-600 font-semibold text-sm whitespace-nowrap hover:bg-white/90 transition-all duration-300 cursor-pointer"
              >
                开始观影
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </section>
        </main>

        <Footer />
        <BackToTopButton />
      </div>
    </>
  );
}